import { RootState } from "../store/root.reducer";
import _ from "lodash";
import normalizeLocale from "./normalizeLocale";
import { getCookie } from "../common/utils/cookie";
import { getTranslation } from "../store/root.selectors";
import { LANGUAGE_COOKIE_KEY } from "../store/attributes/attributes.constants";

export function getLanguageKey(state: RootState) {
  const { config, accountSettings } = state;
  const langs = _.map(config.languages.list, "key");

  const cookieLang = getCookie(LANGUAGE_COOKIE_KEY);
  if (cookieLang && _.includes(langs, cookieLang)) {
    return cookieLang;
  }

  const settingsLang = accountSettings.language;
  if (settingsLang && _.includes(langs, settingsLang)) {
    return settingsLang;
  }

  const defaultLang = config.languages.default;
  if (defaultLang && _.includes(langs, defaultLang)) {
    return defaultLang;
  }

  return _.first(langs);
}

export function getLanguage(state: RootState) {
  const { config } = state;
  return _.find(config.languages.list, { key: getLanguageKey(state) });
}

export const getLocale = (state: RootState) => {
  const { key } = getLanguage(state);
  const translation = getTranslation(state);

  return translation && translation.hasOwnProperty(normalizeLocale(key));
};
